import React from 'react'
import filesize from 'filesize'
import LinearProgress from 'react-md/lib/Progress/LinearProgress';

import './UploadProgress.css'

/* TODO: Fix bug on iPhone 5 where text size increases unexpectedly */

export default ({ title, value }) => (
	<div className="upload-progress-container">
		<LinearProgress
			className="upload-linear-progress"
			id="fileUploadProgress"
			centered
			value={value.progress || 0}
		/>
		<span className="upload-title">
			{title}
		</span>
		<span className="upload-subtitle">
			{`${filesize(value.bytesTransferred || 0)} von ${filesize(value.totalBytes || 0)}`}
		</span>
		<span className="upload-percentage">
			{`${Math.floor(value.progress || 0)} %`}
		</span>
		<span className="upload-spacing" />
	</div>
);


// WEBPACK FOOTER //
// ./src/components/common/UploadProgress.jsx